var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 25V20C15 11.725 17.5 5 30 5C42.5 5 45 11.725 45 20V25",
    stroke: "#1DB954",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 46.25C33.4518 46.25 36.25 43.4518 36.25 40C36.25 36.5482 33.4518 33.75 30 33.75C26.5482 33.75 23.75 36.5482 23.75 40C23.75 43.4518 26.5482 46.25 30 46.25Z",
    stroke: "#1DB954",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 55H17.5C7.5 55 5 52.5 5 42.5V37.5C5 27.5 7.5 25 17.5 25H42.5C52.5 25 55 27.5 55 37.5V42.5C55 52.5 52.5 55 42.5 55Z",
    stroke: "#1DB954",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.65b2d2a1606b033a962496a34ee9f306.svg";
export { ForwardRef as ReactComponent };